import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const SeniorIcon: FC<IconProps> = ({ width = 26, height = 42, ...rest }) => (
  <Icon type="Senior" width={width} height={height} alt="senior" {...rest} />
)
